import { ContractModel } from "../../pages/contracts/models/contracts.models";
import { getContractFixtures } from "./contract-fixtures";
import { MockScenario } from "../mock-scenario";

export const PARTIAL_ERROR_MESSAGE = "Får ikke hentet alle avtalene dine akkurat nå. Prøv igjen om litt.";

export const generateMockContracts = (
  scenario: MockScenario,
): {
  payload: { contracts: ContractModel[]; error?: string };
} => {
  const contracts = getContractFixtures(scenario.contracts).map((fixture) => fixture.contract);

  return {
    payload: scenario.partialError ? { error: PARTIAL_ERROR_MESSAGE, contracts } : { contracts },
  };
};
